import type {DefaultOptions} from '../../../types';
import type {GenerableTextValueEditorLocalizations, GenerableTextValueEditorOptions} from './types';

/**
 * @ngdoc constant
 * @name GENERABLE_TEXT_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.value-editors.generable-text
 *
 * @description
 * For description see {@link GenerableTextValueEditorOptions}
 *
 * ```javascript
 *  {
 *      requestParameters: {},
 *      requestFunction: undefined
 *  }
 * ```
 */
export const GENERABLE_TEXT_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<GenerableTextValueEditorOptions> = {
    requestParameters: {},
    requestFunction: undefined,
};

/**
 * @ngdoc constant
 * @name GENERABLE_TEXT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.generable-text
 *
 * @description
 * ```
 * {
 *     description: '',
 *     generate: 'Generate',
 *     generationError: 'An error occurred during generation'
 * }
 * ```
 */
export const GENERABLE_TEXT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<GenerableTextValueEditorLocalizations>({
    description: '',
    generate: 'Generate',
    generationError: 'An error occurred during generation'
});